export const DIFFICULTY_KEYS = [
  'Beginner',
  'Intermediate',
  'Advanced',
] as const;

export const LANGUAGE_KEYS = [
  'English',
  'Spanish',
  'German',
  'French',
  'Italian',
  'Japanese',
  'Chinese',
  'Korean',
] as const;

export const TAG_KEYS = [
  'DailyLife',
  'FoodAndDrink',
  'Travel',
  'Culture',
  'Business',
  'Technology',
  'Entertainment',
  'Sports',
  'Education',
  'Arts',
  'Music',
  'Literature',
  'CurrentEvents',
  'Science',
  'HealthAndWellness',
  'Hobbies',
] as const;

export const LANGUAGE_EMOJIS: Record<string, string> = {
  English: '🇬🇧',
  Spanish: '🇪🇸',
  German: '🇩🇪',
  French: '🇫🇷',
  Italian: '🇮🇹',
  Japanese: '🇯🇵',
  Chinese: '🇨🇳',
  Korean: '🇰🇷',
};

export const LANGUAGE_IMAGES: Record<string, string> = {
  English: 'https://images.unsplash.com/photo-1526857240824-92be52581d9b',
  Spanish: 'https://images.unsplash.com/photo-1543783207-ec64e4d95325',
  German: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=800',
  French: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=800',
  Italian: 'https://images.unsplash.com/photo-1529260830199-42c24126f198?w=800',
  Japanese: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e',
  Chinese: 'https://images.unsplash.com/photo-1474181487882-5abf3f0ba6c2',
  Korean:
    'https://plus.unsplash.com/premium_photo-1661948404806-391a240d6d40?q=80&w=3272&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
};

export const DEFAULT_ROOM_IMAGE =
  'https://images.unsplash.com/photo-1521737604893-d14cc237f11d';
export const HERO_BG_IMAGE =
  'https://images.unsplash.com/photo-1523240795612-9a054b0db644';

export const difficultyColors = {
  Beginner: {
    border: 'border-green-500 dark:border-green-700',
    bg: 'bg-green-100 dark:bg-green-900',
    text: 'text-green-800 dark:text-green-100',
    header: 'bg-green-50 dark:bg-green-900',
    headerBorder: 'border-green-100 dark:border-green-800',
    icon: 'text-green-600 dark:text-green-400',
    button: 'bg-green-500 hover:bg-green-600',
  },
  Intermediate: {
    border: 'border-yellow-500 dark:border-yellow-700',
    bg: 'bg-yellow-100 dark:bg-yellow-900',
    text: 'text-yellow-800 dark:text-yellow-100',
    header: 'bg-yellow-50 dark:bg-yellow-900',
    headerBorder: 'border-yellow-100 dark:border-yellow-800',
    icon: 'text-yellow-600 dark:text-yellow-400',
    button: 'bg-yellow-500 hover:bg-yellow-600',
  },
  Advanced: {
    border: 'border-red-500 dark:border-red-700',
    bg: 'bg-red-100 dark:bg-red-900',
    text: 'text-red-800 dark:text-red-100',
    header: 'bg-red-50 dark:bg-red-900',
    headerBorder: 'border-red-100 dark:border-red-800',
    icon: 'text-red-600 dark:text-red-400',
    button: 'bg-red-500 hover:bg-red-600',
  },
};
